module.exports = __webpack_public_path__ + "static/media/bounding_box.88e9da3b.png";